export default __webpack_public_path__ + "004960f0c08d773a496ded0e42c60020.png";